import { MaintenanceStatus } from 'core/types/maintenanceStatus';

import { Action, SET_MAINTENANCE_STATUSES } from './actions';

export default (state: MaintenanceStatus[] = [], action: Action) => {
  switch (action.type) {
    case SET_MAINTENANCE_STATUSES:
      return action.payload;
    default:
      return state;
  }
};
